import React, { FC, useEffect, useState } from 'react';
import { Title } from '../../../components/Typogrphy/Title';
import styles from './recruiterLanding.module.less';
import { Button, Spin } from 'antd';
import { TestimonialView } from '../../../components/TestimonialView/TestimonialView';
import { useConnection } from '../../../connection/Application';
import { RecruterCarausal } from './RecruterCarausal';
import ImageDeal from '../../../public/recruiter/recruiter-landing/Business_deal.svg';
import { useRouter } from 'next/router';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { SubscriptionTable } from '../../../components/SubscriptionModel/SubscriptionTable';
import { SubscriptionMobileView } from '../../../components/SubscriptionModel/SubscriptionMobileView';
import { CandidateHomeData } from '../../../page-components/home/HomePage';
import { CompanyLogoList } from '../../../components/companyLogoList/CompanyLogoList';
import { RecruiterBenifitsBanner } from './RecruiterBenifitsBanner';
import { RecruiterTestimonialsBanner } from './RecruiterTestimonials';
import { RecruiterSubscriptionTable } from './RecSubscriptionTable';
import { LandingPageTopSection } from '../../LandingPage/components/LandingPageTopSection';
import { RecruiterLandingTopSection } from './RecruiterLandingTopSection';
import { RecruiterLandingStepsSection } from './RecruiterLandingStepsSection';
import { RecruiterLandingAwardSection } from './RecruiterLandingAwardSection';
import { RecruiterLandingFeaturesSection } from './RecruiterLandingFeaturesSection';

const slides = [
  {
    image: ImageDeal,
    title: 'We’re trusted',
    content: 'Over 1400 employers trust us to deliver the talent they need.',
  },
  {
    image: ImageDeal,
    title: 'We’re trusted',
    content: 'Over 1400 employers trust us to deliver the talent they need.',
  },
  {
    image: ImageDeal,
    title: 'We’re trusted',
    content: 'Over 1400 employers trust us to deliver the talent they need.',
  },
];

const columns = [
  {
    dataIndex: 'name',
    key: 'name',
    visible: false,
    hidden: true,
    width: '30%',
  },
  {
    title: 'Pay Per Add',
    dataIndex: 'payPerAd',
    key: 'payPerAd',

    width: '23%',
  },
  {
    title: 'Standard',
    dataIndex: 'standard',
    key: 'standard',
    width: '23%',
  },
  {
    title: 'Premium',
    key: 'premium',
    dataIndex: 'premium',
    width: '23%',
  },
];

const subscriptionData = [
  {
    key: 1,
    name: 'Number of Job Adverts',
    payPerAd: '1',
    standard: '1',
    premium: '1',
  },
  {
    key: 2,
    name: 'Price per Advert/Additional advert',
    payPerAd: '1',
    standard: '1',
    premium: '1',
  },
  {
    key: 3,
    name: 'Subscription Period',
    payPerAd: '1',
    standard: '1',
    premium: '1',
  },
  {
    key: 4,
    name: 'Duration of Job Adverts',
    payPerAd: '1',
    standard: '1',
    premium: '1',
  },
  {
    key: 5,
    name: 'Featured Job Adverts',
    payPerAd: '1',
    standard: '1',
    premium: '1',
  },
  {
    key: 6,
    name: 'Job Applications Pre Filtering',
    payPerAd: '1',
    standard: '1',
    premium: '1',
  },
  {
    key: 7,
    name: 'Number of Applications per Job Advert',
    payPerAd: '1',
    standard: '1',
    premium: '1',
  },
  {
    key: 8,
    name: 'Allow Candidates to Apply Online',
    payPerAd: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  },
  {
    key: 8,
    name: 'Job Applications Management',
    payPerAd: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  },
  {
    key: 8,
    name: 'Email Templates Management & Applicant Emailing',
    payPerAd: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  },
  {
    key: 9,
    name: 'Download Job Applications',
    payPerAd: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  },
  {
    key: 10,
    name: 'Export Applicants Lists, CSV',
    payPerAd: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  },
  {
    key: 11,
    name: 'Recruiter Analytics',
    payPerAd: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  },
  {
    key: 12,
    name: 'Branded Recruiter Profile',
    payPerAd: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  },
  {
    key: 13,
    name: 'Number of Users',
    payPerAd: <CloseCircleTwoTone twoToneColor="red" />,
    standard: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    premium: <CloseCircleTwoTone twoToneColor="red" />,
  },
  {
    key: 14,
    name: 'Head Hunting (Eyeballing)',
    payPerAd: '1',
    standard: '50',
    premium: '1',
  },
];

type Props = {
  data?: any;
};

type Blogs = {
  blogImage?: string;
  link: string;
};

export const RecruiterLanding: FC<Props> = (props) => {
  console.log('props.data', props.data);
  const [guestData, setGuestData] = useState(props.data?.guestData);
  //const duplicatedData = props.data.topHiring.concat(props.data.topHiring, props.data.topHiring);

  const [tophiring, setTophiring] = useState(props.data?.topHiring);
  const [exrate, setExRate] = useState<number>(props.data?.currency ?? 1);
  const connection = useConnection();
  const history = useRouter();
  // useEffect(() => {
  //   connection
  //     .get(`home/currency/${'USD'}`)
  //     .then((res) => {
  //       // console.log('sponrnew9', res.exRate);
  //       setExRate(res.exRate);
  //     })
  //     .catch((e) => {
  //       console.log('error', e);
  //     });
  // }, [connection]);
  // useEffect(() => {
  //   setLoading(true);
  //   connection
  //     .get('blogs')
  //     .then((v) => {
  //       console.log({ v });
  //       setData(v);
  //     })
  //     .catch((e) => console.log(e))
  //     .finally(() => setLoading(false));
  // }, [connection]);

  return (
    <div className={styles.mainContainer}>
      {/* <div className={styles.titleContainer}>
        <span className={styles.recruiterTitle}>Post a Job</span>
      </div> */}
      <div className={styles.RecruiterMain}>
        <RecruiterLandingTopSection />
        <RecruiterLandingStepsSection />
        <RecruiterLandingAwardSection />
        <RecruiterBenifitsBanner />
        <RecruiterLandingFeaturesSection />

        {/* <div className={styles.recruiterRow}>
          <RecruterCarausal slides={slides} />

        </div> */}

        {/* <div>
          <BlogView items={Data}/>
        </div> */}

        <div className={styles.recruiterRow}>
          <div className={styles.RowContainer}>
            <Title className={styles.keypartnersheadtext} level={1}>
              Key <span className={styles.greenText}> Partners </span> Onboard
            </Title>

            <span className={styles.keypartnerssubheadtext}>
              Careers360 has partnered with <span className={styles.greenText}> 150+ </span> fastest
              growing companies
            </span>
            <div className={styles.logoListContainer}>
              <div className={styles.mobileviewcompanies}>
                <CompanyLogoList lg={4} logos={tophiring?.slice(0, 18) ?? []} logosperslide={9} />
              </div>
              <div className={styles.desktopviewcompanies}>
                <CompanyLogoList lg={4} logos={tophiring?.slice(0, 11) ?? []} logosperslide={9} />
              </div>
            </div>
            <div
              className={styles.btnContainer}
              style={{ alignSelf: 'center', marginTop: '80px', marginBottom: '80px' }}>
              <Button
                type={'primary'}
                onClick={() => history.push('/recruiters')}
                className={styles.testimonialbtnPrimary}>
                View All
              </Button>
            </div>
          </div>
        </div>
        <RecruiterTestimonialsBanner data={guestData} />

        <div className={styles.recruiterRow1}>
          <div className={styles.RowContainer}>
            <Title
              level={1}
              className={styles.SubsciptionsTitle}
              style={{ textAlign: 'center', paddingTop: '100px' }}>
              Ready to start with <span style={{ color: '#009E52' }}>Careers360? </span>
            </Title>
            <span className={styles.pricingPlansubheading}>Our Recruiter Solutions</span>
          </div>
        </div>
      </div>
      <RecruiterSubscriptionTable hideSubscribe={true} exchangeRate={exrate ?? 1} />
      {/* <div className={styles.mobilewidth}>
        <SubscriptionMobileView />
      </div>
      <div className={styles.desktopwidth}>
        <RecruiterSubscriptionTable hideSubscribe={true} />
      </div> */}
    </div>
  );
};
